export const v2Routes = [
  {
    path: '/v2/operate',
    name: 'V2OperateOverview',
    component: () => import('@/pages/v2/operate/OperateOverview.vue'),
    meta: { requiresAuth: true, featureFlag: 'optionCOperateV2' },
  },
  {
    path: '/v2/manage',
    name: 'V2ManageOverview',
    component: () => import('@/pages/v2/manage/ManageOverview.vue'),
    meta: { requiresAuth: true, featureFlag: 'optionCManageV2' },
  },
  {
    path: '/v2/analyze',
    name: 'V2AnalyzeOverview',
    component: () => import('@/pages/v2/analyze/AnalyzeOverview.vue'),
    meta: { requiresAuth: true, featureFlag: 'optionCAnalyzeV2' },
  },
  {
    path: '/v2/admin',
    name: 'V2AdminOverview',
    component: () => import('@/pages/v2/admin/AdminOverview.vue'),
    meta: { requiresAuth: true, featureFlag: 'optionCAdminV2' },
  },
  {
    path: '/v2/tools',
    name: 'V2ToolsOverview',
    component: () => import('@/pages/v2/tools/ToolsOverview.vue'),
    meta: { requiresAuth: true, featureFlag: 'optionCToolsV2' },
  },
];
